import { fade, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  itemsCalculations: {
    backgroundColor: theme.palette.colors.table,
    padding: theme.spacing(1.5),
    '& .total': {
      color: theme.palette.common.black,
      fontSize: theme.typography.pxToRem(18),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      '& .MuiInputLabel-root': {
        color: theme.palette.common.black,
        fontWeight: theme.typography.fontWeightSemiBold
      }
    },
    '& .info': {
      alignItems: 'center',
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      marginBottom: theme.spacing(0.75),
      [theme.breakpoints.down('md')]: {
        width: '100%'
      },
      '& .MuiInputLabel-root': {
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(0),
        minHeight: 'auto',
        color: theme.palette.text.secondary
      },
      '& .info-data': {
        flex: '1 1 auto',
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(0),
        textAlign: 'right'
      }
    }

  },
  senderReceiverWrapper: {
    [theme.breakpoints.only('md')]: {
      marginTop: theme.spacing(2),
      display: 'flex',
      justifyContent: 'space-between'
    }
  },
  senderReceiver: {
    '& .MuiAccordion-root.Mui-expanded:last-child': {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      width: '100%'
    },
    [theme.breakpoints.only('md')]: {
      width: `calc( 50% -  ${theme.spacing(2)}px)`,
      '& .MuiAccordion-root.Mui-expanded:last-child': {
        marginTop: theme.spacing(0)
      },
      '& .MuiAccordion-root': {
        // height: '54px',
        // transition: 'height 0.3s ease-in-out',
        '&.Mui-expanded': {
          height: '100%'
        }
      }
    }
  },

  paymentDeliveryWrapper: {
    display: 'flex',
    marginTop: theme.spacing(2),
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap'
    }
  },
  paymentDelivery: {
    [theme.breakpoints.down('sm')]: {
      '& .MuiAccordion-root.Mui-expanded:last-child': {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
      }
    },
    [theme.breakpoints.up('md')]: {
      width: '100%',
      // display: 'flex',
      '&:nth-child(2)': {
        marginLeft: theme.spacing(4)
      },
      '& .MuiAccordion-root': {
        // height: '54px',
        // transition: 'height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        '&.Mui-expanded': {
          height: '100%'
        }
      }
    }
  },
  CertificatesWrapper: {
    width: '100%',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  CertificatesLabel: {
    color: theme.palette.text.light,
    lineHeight: 1.3,
    width: '100%',
    fontSize: theme.typography.pxToRem(18)
  },
  CertificatesContainer: {
    marginTop: theme.spacing(1),
    backgroundColor: fade(theme.palette.primary.light, 0.1),
    borderRadius: theme.spacing(1.5)
  },

  CertificateContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    '& > svg': {
      marginRight: theme.spacing(2),
      transition: 'all 0.3s ease-in-out',
      color: theme.palette.primary.main
    }
  },
  CertificateContent: {
    flex: '1 1 auto',
    '& > strong': {
      color: theme.palette.primary.dark,
      transition: 'all 0.3s ease-in-out',
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.pxToRem(18)
    }
  },
  CertificateHeader: {
    color: theme.palette.grey['500'],
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '100%',
    transition: 'all 0.3s ease-in-out',
    fontWeight: theme.typography.fontWeightSemiBold,
    '& span:not(:last-child)': {
      marginRight: theme.spacing(1)
    }
  },
  CertificateFooter: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '100%',
    transition: 'all 0.3s ease-in-out',
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightBold,
    '& span:not(:last-child)': {
      marginRight: theme.spacing(1)
    },
    '& .error': {
      color: theme.palette.error.main
    }
  },


  CertificateWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(0),
    marginRight: theme.spacing(0),
    padding: theme.spacing(2),
    transition: 'all 0.3s ease-in-out',
    '& .MuiRadio-root': {
      transition: 'all 0.3s ease-in-out',
    },
    '& .MuiFormControlLabel-label': {
      flex: '1 1 auto',
      marginLeft: theme.spacing(1)
    },
    '&:hover, &.selected': {
      boxShadow: `0px 2px 4px -1px ${fade(theme.palette.common.black, 0.2)}, 0px 4px 5px 0px ${fade(theme.palette.common.black, 0.14)}, 0px 1px 10px 0px ${fade(theme.palette.common.black, 0.12)}`,
      backgroundColor: theme.palette.primary.main,

      '& $CertificateHeader, & $CertificateFooter,  & $CertificateContainer > svg, & $CertificateContent > strong, & .MuiRadio-root:not(.Mui-checked)': {
        color: theme.palette.common.white,
      }
    }
  }
}))
